import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useAffiliateStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncAffilateStatus } = useMutation('updateAffiliateStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['affiliates'] });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncAffilateStatus };
};

export default useAffiliateStatus;
